import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './XLintroduce.css';

const XLintroduce: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="xl-introduce-container">
      <Header />

      <section className="xl-introduce-mission">
        <div className="xl-mission-inner">
          <p className="xl-mission-label">我们的使命</p>
          <h2 className="xl-mission-title">公司历程：一路走来，坚守初心</h2>
          <p className="xl-mission-text">
            我们始终秉持创新与服务的精神，不断推进AI技术的发展，为各行各业提供优质的生产力工具。自公司成立以来，我们持续加大研发力度，每一步都为客户提供更好的服务与体验。我们的目标是成为行业内值得信赖的合作伙伴，与客户一同成长，共同创造美好的未来。
          </p>
        </div>
      </section>

      <section className="xl-introduce-content">
        <div className="xl-content-inner">
          <div className="xl-timeline-wrapper">
            <div className="xl-timeline-item">
              <div className="xl-timeline-header">
                <span className="xl-timeline-date">2025年11月06日</span>
                <span className="xl-timeline-separator">-</span>
                <span className="xl-timeline-event">公司成立</span>
              </div>
              <p className="xl-timeline-desc">
                几个满腔热血的有志青年，聚在一起，成立了杭州序列深维科技有限公司，致力于为各行各业提供与时俱进的生产工具。
              </p>
            </div>
            <div className="xl-timeline-item">
              <div className="xl-timeline-header">
                <span className="xl-timeline-date">2026年3月15日</span>
                <span className="xl-timeline-separator">-</span>
                <span className="xl-timeline-event">序点生产力平台上线</span>
              </div>
              <p className="xl-timeline-desc">
                旨在为客服和医疗行业提供生产力工具的序点平台上线。
              </p>
              <div className="xl-icon-wrapper">
                <img src={`${process.env.PUBLIC_URL}/image/xd-logo1024-20260601.png`} alt="序列·生产力平台" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl-introduce-team">
        <div className="xl-team-inner">
          <h2 className="xl-team-title">我们的团队</h2>
          <p className="xl-team-text">
            在这里，我们汇聚了各领域的专业人士，共创新未来。
          </p>
        </div>
      </section>

      <section className="xl-introduce-cta">
        <div className="xl-cta-inner">
          <h2 className="xl-cta-title">联系我们，共同探索新机遇</h2>
          <p className="xl-cta-text">
            我们期待与您交流，您的反馈对我们至关重要！请填写下面的联系表单，告诉我们您的想法或需求，我们将尽快与您取得联系，并探讨合作的可能性。
          </p>
          <button className="xl-cta-btn" type="button" onClick={() => navigate('/contact')}>
            联系我们
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default XLintroduce;
